import React from 'react';
import i18n from 'i18n';
import YamlView from 'components/YamlView';
import './audit-status-cell-renderer.scss';
import yaml from 'yaml';

type KeyVaueType = {
  field: string;
  before?: unknown;
  after?: unknown;
  value?: unknown;
}

const ReactJsonView = (props: any) => {
  const { data, status } = props;

  const parseAuditData = (adutiData: string) => {
    const parsedData = JSON.parse(adutiData);

    if (data?.actionType === 'Edit' && Array.isArray(parsedData)) {
      const final = parsedData
        .reduce((total: {[key: string]: unknown}, actual: KeyVaueType | {[key:string]: unknown}) => {

          if (actual.field != null && (actual.before != null || actual.after != null)) {
            return {
              ...total,
              [(actual as KeyVaueType).field]: { before: actual.before, after: actual.after, fromEdit: true },
            };
          }

          return {
            ...total,
            ...actual,
          };
        }, {});

      return final;
    }

    if (Array.isArray(parsedData)) {
      return parsedData
        .reduce((total: {[key: string]: unknown}, actual: KeyVaueType | {[key:string]: unknown}) => {

          if (actual.field == null && actual.value == null) {
            return {
              ...total,
              ...actual,
            };
          }

          return ({
            ...total,
            [(actual as KeyVaueType).field]: actual.value,
          });
        }, {});
    }

    return parsedData;
  };

  if (JSON.parse(data?.fieldDetails) == null || data?.fieldDetails === '{}') {
    return <div className="react-json-view">-</div>;
  }

  const renderStatus = () => {
    if (status === '200 OK') {
      return null;
    }

    return (
      <div className="failed">
        {i18n.t('audit.useraudit.grid.statusError')}
      </div>
    );
  };

  const PrettyPrintJson = (data: any) => {
    const parsedData = JSON.parse(data);
    return (<div className="yaml-view"><pre className="yaml-view-key-value edit-json-yaml-font">{ yaml.stringify(parsedData) }</pre></div>);
  }

  return (
    <div className="react-json-view">
      {renderStatus()}
      <div className="react-json-view-yaml-view">
        {data?.actionType === 'Edit' ? PrettyPrintJson(data?.fieldDetails) : <YamlView data={parseAuditData(data?.fieldDetails)} />}
      </div>
    </div>
  );
};

export default ReactJsonView;
